/**
 * @generated SignedSource<<7f83f450dfcc9fbf52cf578680f81723>>
 * @relayHash 8ba289969fdfef4cfb9de7089b35e65e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5feaa54c4f48255ec0ebfffdd1953e451f632233b0c2f24fffcf59ba8bb7dc5c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type cardColorsSettingsPageQuery$variables = {
  boardId: string;
};
export type cardColorsSettingsPageQuery$data = {
  readonly boardScope: {
    readonly cardColorConfig: {
      readonly cardColorStrategies: ReadonlyArray<{
        readonly canEdit: boolean;
        readonly cardColors: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly color: string;
              readonly displayValue: string;
              readonly id: string;
              readonly isGlobalColor: boolean | null | undefined;
              readonly isUsed: boolean;
              readonly strategy: string;
              readonly value: string;
            };
          } | null | undefined>;
        };
        readonly id: string;
      } | null | undefined>;
      readonly cardColorStrategy: string;
    };
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
  };
};
export type cardColorsSettingsPageQuery = {
  response: cardColorsSettingsPageQuery$data;
  variables: cardColorsSettingsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  },
  {
    "kind": "Literal",
    "name": "isCMP",
    "value": true
  }
],
v2 = {
  "concreteType": "CurrentUser",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "permissions"
    }
  ]
},
v3 = {
  "kind": "ScalarField",
  "name": "cardColorStrategy"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v6 = {
  "kind": "ScalarField",
  "name": "strategy"
},
v7 = {
  "kind": "ScalarField",
  "name": "value"
},
v8 = {
  "kind": "ScalarField",
  "name": "displayValue"
},
v9 = {
  "kind": "ScalarField",
  "name": "color"
},
v10 = {
  "kind": "ScalarField",
  "name": "isUsed"
},
v11 = {
  "kind": "ScalarField",
  "name": "isGlobalColor"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "cardColorsSettingsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "JswCardColorConfig",
                "kind": "LinkedField",
                "name": "cardColorConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": (v3/*: any*/),
                    "action": "THROW",
                    "path": "boardScope.cardColorConfig.cardColorStrategy"
                  },
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JswCardColorStrategy",
                      "kind": "LinkedField",
                      "name": "cardColorStrategies",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": (v4/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.cardColorConfig.cardColorStrategies.id"
                        },
                        {
                          "kind": "RequiredField",
                          "field": (v5/*: any*/),
                          "action": "THROW",
                          "path": "boardScope.cardColorConfig.cardColorStrategies.canEdit"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JswCardColorConnection",
                            "kind": "LinkedField",
                            "name": "cardColors",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JswCardColorEdge",
                                  "kind": "LinkedField",
                                  "name": "edges",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "concreteType": "JswCardColor",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "RequiredField",
                                            "field": (v4/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.id"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v6/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.strategy"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v7/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.value"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v8/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.displayValue"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v9/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.color"
                                          },
                                          {
                                            "kind": "RequiredField",
                                            "field": (v10/*: any*/),
                                            "action": "THROW",
                                            "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node.isUsed"
                                          },
                                          (v11/*: any*/)
                                        ]
                                      },
                                      "action": "THROW",
                                      "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges.node"
                                    }
                                  ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors.edges"
                              }
                            ]
                          },
                          "action": "THROW",
                          "path": "boardScope.cardColorConfig.cardColorStrategies.cardColors"
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "boardScope.cardColorConfig.cardColorStrategies"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.cardColorConfig"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cardColorsSettingsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "JswCardColorConfig",
            "kind": "LinkedField",
            "name": "cardColorConfig",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JswCardColorStrategy",
                "kind": "LinkedField",
                "name": "cardColorStrategies",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "concreteType": "JswCardColorConnection",
                    "kind": "LinkedField",
                    "name": "cardColors",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JswCardColorEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JswCardColor",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v10/*: any*/),
                              (v11/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5feaa54c4f48255ec0ebfffdd1953e451f632233b0c2f24fffcf59ba8bb7dc5c",
    "metadata": {},
    "name": "cardColorsSettingsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e4787dfed088870f48db1ecbe159e44";

export default node;
